import PageHeader from './PageHeader.vue'

export default PageHeader